export default class TransportEquipment {
  type;
  constraints;

  constructor() {
    this.type = 'transportEquipment';
    this.constraints = [];
  }
}
